<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Service</li>
  </app-tabs>
  <app-amenity-index class="flex-control flex-column" [hidden]="tabs_service.is_active()"></app-amenity-index>
</div>
